import {app} from '../app';
import IPromise = angular.IPromise;

export interface IBrowserControlService {
    disableBackButton(prevented: () => void);
    enableBackButton();
}

export class BrowserControlService implements IBrowserControlService {

    private rootScope:IRootScope;
    private location: ng.ILocationService;

    private disableBackButtonUnsubscribe: () => void;

    constructor($rootScope:IRootScope, $location: ng.ILocationService) {
        this.rootScope = $rootScope;
        this.location = $location;
    }

    public disableBackButton(prevented: () => void) {
        this.rootScope.actualLocation = this.location.absUrl();

        let unsubscribe1 = this.rootScope.$on('$locationChangeSuccess', () => {
            this.rootScope.actualLocation = this.location.absUrl();
        });

        let unsubscribe2 = this.rootScope.$watch(
            () => this.location.absUrl(),
            (newLocation, oldLocation) => {
                if (this.rootScope['actualLocation'] === newLocation && oldLocation !== newLocation) {
                    prevented();
                }
            });

        this.disableBackButtonUnsubscribe = () => {
            unsubscribe1();
            unsubscribe2();
        };
    }

    public enableBackButton() {
        if (this.disableBackButtonUnsubscribe) {
            this.disableBackButtonUnsubscribe();
            this.disableBackButtonUnsubscribe = null;
        }
    }

    static factory() {
        const factory = ($rootScope:IRootScope, $location: ng.ILocationService) => new BrowserControlService($rootScope, $location);
        factory.$inject = ['$rootScope', '$location'];
        return factory;
    }
}

app.factory('BrowserControlService', BrowserControlService.factory());